import { html, LitElement } from "lit";
import {
  defaultLocale,
  i18nLocales,
  languageNames,
} from "../../../src/config/i18n.js";
import { ROUTES } from "../../../src/routes/constants.js";
import { svgIcon } from "../../../src/utils/icon.js";

export class LanguageDropdown extends LitElement {
  static properties = {
    value: { type: String, attribute: "value" },
    label: { type: String, attribute: "label" },
    endpoint: { type: String, attribute: "endpoint" },
    config: { type: Object, attribute: "config" },
  };

  constructor() {
    super();
    this.value = defaultLocale;
    this.label = "Language";
    this.endpoint = ROUTES.API.I18N_LOCALE;
  }

  willUpdate(changedProperties) {
    if (changedProperties.has("config")) {
      this._parseConfig();
    }
  }

  _parseConfig() {
    if (typeof this.config === "string") {
      try {
        this.config = JSON.parse(this.config);
      } catch (e) {
        console.error("Failed to parse config:", e);
        this.config = { locales: i18nLocales, languageNames };
      }
    }

    // Ensure config has required properties, can be both string or object
    if (!this.config || typeof this.config !== "object") {
      this.config = { locales: i18nLocales, languageNames };
    }
  }

  async handleChange(e) {
    const nextLocale = e.target?.value;
    if (!nextLocale || nextLocale === this.value) return;

    const body = new URLSearchParams();
    body.set("locale", nextLocale);

    await fetch(this.endpoint, {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body,
      credentials: "same-origin",
    });

    const ot = window?.OneTrust;
    if (ot?.IsAlertBoxClosedAndValid?.()) {
      ot.changeLanguage(String(nextLocale).split("-")[0]); // OneTrust only supports language code like 'en', 'fr'
    }

    window.location.reload();
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div class="trigger">
        ${svgIcon("translate-outlined")}
        <div class="select-wrap">
          <select name="locale" aria-label="${this.label}" @change="${this.handleChange}">
            ${this.config.locales.map(
              (lng) =>
                html`
                  <option value="${lng}" ?selected="${lng === this.value}">
                    ${this.config.languageNames[lng] || lng}
                  </option>`,
            )}
          </select>
          <div class="trigger-icon">${svgIcon("chevron-right-outlined")}</div>
        </div>
      </div>
    `;
  }
}

customElements.define("language-dropdown", LanguageDropdown);
